// extracted by mini-css-extract-plugin
export default {"authenticationBox":"AuthenticationBox_authenticationBox__fSa47","logo":"AuthenticationBox_logo__Ozku9","title":"AuthenticationBox_title__VX95o"};